import { Box } from '@mui/material';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@design-system/collapsible';
import type { FC } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { ExpandMore } from '@mui/icons-material';
import type { TBankAccount } from '@shared/types/bank-account';

const FinancialDetailsCollapse: FC<{ bankInfo: TBankAccount }> = ({
  bankInfo,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <Box
      className='w-full border border-primary-200 rounded-lg py-3 px-3 mt-4'
      sx={{ bgcolor: '#fdfdfe' }}
    >
      <Collapsible
        open={open}
        onOpenChange={setOpen}
      >
        <CollapsibleTrigger asChild>
          <button className='flex items-center justify-between w-full text-lg font-semibold'>
            <p className='text-gray-800 text-lg font-medium flex items-center gap-1'>
              Financial Details
            </p>
            <motion.div
              animate={{ rotate: open ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <ExpandMore className='w-6 h-6' />
            </motion.div>
          </button>
        </CollapsibleTrigger>

        <CollapsibleContent className='overflow-hidden mt-4'>
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className='text-gray-600 text-sm mb-1'>Bank Name</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bankInfo.bank_name}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Beneficiary Name</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bankInfo.beneficiary_name}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Account Number</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bankInfo.account_number}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Currency</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bankInfo.currency}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Routing Number/IBAN</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bankInfo.iban}
            </p>

            <p className='text-gray-600 text-sm mb-1'>SWIFT</p>
            <p className='text-gray-800 font-medium text-sm'>
              {bankInfo.swift_code}
            </p>
          </motion.div>
        </CollapsibleContent>
      </Collapsible>
    </Box>
  );
};

export default FinancialDetailsCollapse;
